
import { TitleComponent } from "ui-components";
import { HorizontalCard, Amount, Label } from "../../components/common";

import SocialChart from "../../components/common/graph/social";
import { CompanyType } from "ui-io/company-io";
import styled from "styled-components";

type Props = {
  currentCompany?: CompanyType;
};
const CompanySocial = (props: Props) => {
  const { currentCompany } = props;

  // const data = [10, 20, 15, 30, 25, 35, 30];
  // const labels = ["Jan,2020", "Apr,2020", "Jul,2020", "Oct,2020", "Jan,2021"];
  // const funding = "$24M";
  // const stage = "Early Stage VC (Series A)";

  const data = [10, 20, 15, 5, 28, 30, 25, 35, 10, 30, 8, 38, 40];
  const labels = ["Jan,2020", "Apr,2020", "Jul,2020", "Oct,2020", "Jan,2021"];
  return (
    <>
      <div>
        <TitleComponent>Company Socials</TitleComponent>
        <div className="display-flex justify-between align-center gap-3 mt-md">
          <HorizontalCard avatarIcon={"/icons/socials/web.svg"}>
            <Amount className="mt-xs">$2.9M</Amount>
            <StyledLabel>Web Traffic</StyledLabel>
          </HorizontalCard>
          <HorizontalCard avatarIcon={"/icons/socials/twitter.svg"}>
            <Amount className="mt-xs">25</Amount>
            <StyledLabel>Twitter Followers</StyledLabel>
          </HorizontalCard>
          <HorizontalCard avatarIcon={"/icons/socials/linkedin.svg"}>
            <Amount className="mt-xs">$3.7M</Amount>
            <StyledLabel>Linkedin Followers</StyledLabel>
          </HorizontalCard>
        </div>
      </div>
      <div className="mt-xxlg">
        <SocialChart data={data} labels={labels} />
      </div>
    </>
  );
};

export default CompanySocial;

const StyledLabel = styled(Label)`
	white-space: nowrap;
`
